import  { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Scrollbar from '../../components/scrollbar/scrollbar'
import FaqSection from '../../components/Faq/FaqSection';
import AboutDoctorHero from '../../components/hero/AboutDoctorHero';
import TestimonialStyle3 from '../../components/Testimonial/TestimonialStyle3';
import { InsuranceSection } from '../InsurancePage/InsurancePage';
import DentalServicesSectionStyle2 from '../../components/ServiceSection/DentalServicesSectionStyle2';
import FeatureStyle2 from '../../components/Features/FeatureStyle2';
import Footer from '../../components/footer/Footer';
import AppoinmentSection from '../../components/AppoinmentSec/AppoinmentSection';
import { LocationSection } from '../LocationPage/LocationPage';
import OfficeHeroStyle2 from '../../components/hero2/OfficeHeroStyle2';
import Welcome from '../../components/welcome/Welcome';
// import { TechnologySectionStyle2 } from '../../components/hero2/technologyStyle2';
import { Helmet } from 'react-helmet';
import { TechnologySection } from '../../components/hero2/technology';
const HomePage = () => {

    return (
        <Fragment>
            <Helmet>
                <title>Home | Comprehensive dental office Manvel TX</title>
                <meta name="description" content="Up Dental Of Manvel | Comprehensive dental office in Manvel TX"  />
                <meta name="keywords" content="dental, dentist, Manvel, treatment, patients, office, appointment" />
            </Helmet>
            <Navbar />
            <Welcome />
            
            <LocationSection class={"section-padding"}/>
            <FeatureStyle2 />
            <DentalServicesSectionStyle2 />
            {/* <TechnologySectionStyle2 /> */}
            <TechnologySection />
            <OfficeHeroStyle2 class={"section-bg"}/>
            
            <AboutDoctorHero />          
            <InsuranceSection />
            <TestimonialStyle3 />
            <FaqSection questionNum={5}/>
            <AppoinmentSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default HomePage;